// super simple module for the most common nodejs use case.
exports.markdown = require("./markdown");
exports.parse = exports.markdown.toHTML;



//////////////////
// WEBPACK FOOTER
// ./node_modules/markdown/lib/index.js
// module id = 67
// module chunks = 0